import React from 'react';
import './Badge.module.scss';

const MLBadge = ({ text, color = 'default' }) => {
  return <div className={`badge ${color}`}>{text}</div>;
};

export default MLBadge;
